import React, { FC } from 'react';
import { DefaultItemsList } from '@v2/pages/machines/common/components/ItemsList/DefaultItemsList';
import { NavigationProps } from '@interfaces/navigation';
import EventCharts, { EventCharts as EventChartsInnerComponent } from '@components/machines/components/eventsChart';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import PerformanceScreenNet from '@v2/pages/performance/common/components/PerformanceScreenNet';
import { MODE } from '@v2/pages/machines/common/enums';
import { isPhone, isWeb } from '@helpers';
import { useChangeDisplayModeOnResize } from '@v2/pages/common/hooks/useChangeDisplayModeOnResize';

interface PerformanceActiveProps extends NavigationProps {}

const PerformanceActive: FC<PerformanceActiveProps> = ({ lg }) => {
  const { mode } = useChangeDisplayModeOnResize();

  return (
    <MachinesProvider
      mode={isWeb ? mode : isPhone ? MODE.DETAILS : MODE.FULL}
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <DefaultItemsList {...props} data={props.machineStatistics.data} machinesLoaded={props.machineStatistics.loaded} />}
    >
      <PerformanceScreenNet screenName="MachinesPerformanceActive">
        <EventCharts getContentElement={(props) => <EventChartsInnerComponent {...props} />} />
      </PerformanceScreenNet>
    </MachinesProvider>
  );
};

export { PerformanceActive };
